<template>
  <ul class="profession-step">
    <li v-for="(item, index) in list" :key="item.title" :class="[ currentStep >= index ? 'active' : '' ]">
      <div class="step-box">
        <div class="num">{{ index + 1 }}</div>
        <div class="title">{{ item.title }}</div>
        <div v-if="currentStep >= index && index !== list.length -1 " class="arrow">
          <img class="slot-empty-img" src="@/assets/preogress.png" alt="">
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'MyStep',
  props: {
    list: {
      // { status: 'primary info warning error' },
      type: Array,
      default: () => []
    },
    isDialog: {
      type: Boolean,
      default: () => false
    },
    currentStep: {
      // 当前步骤
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    }
  },
  computed: {},
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
.profession-step {
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  li {
    flex: 1;
    height: 48px;

    .step-box {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 0;
      background: #F7F8FA;
      position: relative;

      .num {
        height: 24px;
        line-height: 24px;
        width: 24px;
        margin-right: 8px;
        background: #E5E6EB;
        border-radius: 12px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 500;
        color: #1D2129;
      }

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1D2129;
        line-height: 20px
      }
      .arrow{
        position: absolute;
        right: -11px;
        top: 0;
        height: 48px;
        z-index: 10;
        img{
          height: 48px;
        }
      }
    }

    &.active {
      .step-box {
        background: #DEEAFF;
      }

      .num {
        background: #165DFF;
        color: #FFFFFF;
      }

      .title {
        color: #165DFF;
      }

      &:first-child {
        border-radius: 4px 0 0 4px;
      }
    }
  }
}
</style>
